// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useGateValue } from '@statsig/react-bindings';
import { useState } from 'react';
import { NavLink } from 'react-router-dom';
import ReactSelect, { components } from 'react-select';
import logo from '../icons/logo.png';
import tempCertLogo from '../icons/temp-cert-logo.png';
import tempJobsLogo from '../icons/temp-jobs-logo.png';
import tempPrepLogo from '../icons/temp-prep-logo.png';
import styles from './DesktopAppHeader.module.css';
import mobileStyles from './MobileAppHeader.module.css';

const CustomOption = (props) => {
  return (
    <components.Option {...props}>
      <img
        src={props.data.image}
        alt={props.data.label}
        style={{
          width: props.data.width,
          height: props.data.height,
          marginRight: 10,
        }}
      />
      {props.data.label}
    </components.Option>
  );
};

const CustomMenu = (props) => {
  return (
    <components.Menu {...props}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {props.children}
      </div>
    </components.Menu>
  );
};
const CustomMenuList = (props) => {
  return (
    <components.MenuList {...props}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
        }}
      >
        {props.children}
      </div>
    </components.MenuList>
  );
};

const customStyles = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  control: (provided, state) => ({
    ...provided,
    backgroundColor: 'transparent', // Set background to transparent
    border: 'none', // Remove the border
    boxShadow: 'none', // Remove the default box-shadow
    cursor: 'text', // Set cursor to text for better UX
    '&:hover': {
      border: 'none', // Ensure border doesn't appear on hover
    },
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: 0, // Remove padding for a tighter layout
  }),
  input: (provided) => ({
    ...provided,
    margin: 0,
    padding: 0,
    color: 'inherit', // Inherit color from parent
  }),

  singleValue: (provided) => ({
    ...provided,
    color: 'inherit', // Inherit color from parent
  }),
  indicatorSeparator: () => ({
    display: 'none', // Remove the separator between the value and indicators
  }),
  menu: (provided) => ({
    ...provided,
    width: '', // Ensure the menu width matches the control
  }),
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  option: (provided, state) => ({
    ...provided,
    backgroundColor: 'white', // Keep selected item highlighted
    ':hover': {
      backgroundColor: 'white', // No background color change on hover
    },
  }),
};

const options = [
  {
    value: 'prep',
    label: '',
    width: 60,
    height: 60,
    image: tempPrepLogo,
    url: '/',
  },
  {
    value: 'cert',
    label: '',
    width: 100,
    height: 60,
    image: tempCertLogo,
    url: 'https://240certification.com',
  },
  {
    value: 'jobs',
    label: '',
    width: 60,
    height: 60,
    image: tempJobsLogo,
    url: 'https://jobs.240.org',
  },
  {
    value: 'content',
    label: '',
    width: 60,
    height: 50,
    image: logo,
    url: 'https://cgraph.240.org',
  },
];

const CustomSingleValue = (props) => (
  <components.SingleValue {...props}>
    <img
      src={props.data.image}
      alt={props.data.label}
      style={{
        width: props.data.width,
        height: props.data.height,
        marginRight: 10,
      }}
    />
    {props.data.label}
  </components.SingleValue>
);

const NavLogo = () => {
  const portalEnabled = useGateValue('enable_app_portal');
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [width, setWidth] = useState(window.innerWidth);

  return (
    <>
      {portalEnabled ? (
        <ReactSelect
          className={`${styles.selectLogo}`}
          value={options[0]}
          options={options}
          styles={customStyles}
          isSearchable={false}
          components={{
            Option: CustomOption,
            SingleValue: CustomSingleValue,
            MenuList: CustomMenuList,
            Menu: CustomMenu,
          }}
          onChange={(event) => {
            window.location = event.url;
          }}
        />
      ) : width < 700 ? (
        <NavLink className={mobileStyles.logo} to="/">
          <img src={logo} alt="240 Tutoring" />
        </NavLink>
      ) : (
        <NavLink className={styles.logo} to="/">
          <img src={logo} alt="240 Tutoring" />
        </NavLink>
      )}
    </>
  );
};

export default NavLogo;
